import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const TextGlowBlurListItem = (props) => {
    const { glowSettingsBlur, updateTextElement, index, maxGlowBlur } = props;
    
    const onGlowBlurChange = (value) => {
        previewHistoryBatch.start();
        
        updateTextElement(index, { 
            glowSettings: { blur: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Blur'
            value={glowSettingsBlur}
            displayMultiplier={100 / maxGlowBlur}
            min={0}
            max={100}
            step={1}
            onValueChange={onGlowBlurChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const glowSettingsBlur = element && element.glowSettings ? element.glowSettings.blur : 0;
    const { maxGlowBlur } = state.create.maxValues;

    return { 
        glowSettingsBlur,
        maxGlowBlur
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextGlowBlurListItem);
